import React from 'react';
import styles from "./Header.module.scss";
import clsx from 'clsx';
import LogoImg from "../../../assets/images/logo.png";
import PropTypes from "prop-types";
import HeaderActions from "../header-actions/HeaderActions";
import {HeaderDrawerProvider, MobileDrawer} from "../mobile-drawer";
import AppRoutes from "settings/app-routers";

export const Header = (props) => {
    return (
        <HeaderDrawerProvider>
          <header className={clsx(styles.header)}>
              <nav className={clsx("navbar navbar-expand-sm flex-flex-d-center- h-full", styles.bgHeader)}>
                  <div className={styles.logoContainer}>
                      <img className={styles.headerLogo} src={LogoImg} alt="logo" onClick={() => props.checkNewReportStatus(AppRoutes.home)}/>
                      <MobileDrawer  {...props} />
                  </div>

                  <h3 className={styles.title}>{props.title}</h3>

                  <HeaderActions {...props}/>
              </nav>
          </header>
        </HeaderDrawerProvider>
    );
};

Header.propTypes = {
    isAuthenticated: PropTypes.bool,
    checkNewReportStatus: PropTypes.func,
    onSignOut: PropTypes.func,
    userInfo: PropTypes.any,
    title: PropTypes.string,
}

Header.defaultProps = {
    isAuthenticated: false,
    title: 'ID AUTO REPORTES'
}

export default React.memo(Header);
